import { AppDate } from '../envTypes';

import { ModelBase } from './base';

export enum ShopifySyncStatus {
  NotStart = 'NotStart',
  Success = 'Success',
  Failed = 'Failed',
}

export interface ShopifyProduct {
  title: string;
  imageUrl: string;
  price: string;
  sku?: string;
  description?: string;
  /** @TJS-type integer */
  quantity?: number;
}

export interface ShopifyStore {
  shopName: string;
  accessToken?: string;
  updatedAt: AppDate;
  uuid?: string;
  autoSync?: boolean;
  locationId?: string;
  userId: string;
  writeDraftOrders?: boolean;
}

export interface ShopifySync {
  orderId: string;
  listingId: string;
  varaintId: string;
  quantity: number;
  total: number;
  storeId: string;
  shopifyStoreName: string;
  syncStatus: ShopifySyncStatus;
}

export interface ShopifySyncedOrder {
  orderId: string;
  shopifyOrderId: string;
  shopifyStoreId: string;
}

export interface ShopifyBulkUploadHistory extends ModelBase {
  shopifyStoreId: string;
  shopifyStoreName: string;
  csvUrl: string;
  listingsCount: number;
}
